import { DemoApiMock } from '../types'
import { getDemoData, matchRestRequest } from '../utils'

export const mockGetInsights: DemoApiMock = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/company_insight_ef6beefc',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()
    return {
      data: {
        company: {
          insight: demoData.insights,
        },
      },
    }
  },
}
